module.exports = __webpack_public_path__ + "img/3.1aad6eb1.png";